import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators'; // Importamos el operador take
import { ReactivateService } from './reactivate.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { ZenriseDebtData } from '@pedix-workspace/utils';
import { AppCurrencyFormatService } from '../../shared/app-currency-format.service';
import { IconLoadingComponent } from '@pedix-workspace/angular-ui-icons';
import { ReactivatePaymentComponent } from './reactivate-payment/reactivate-payment.component';

@Component({
    selector: 'app-reactivate',
    templateUrl: './reactivate.component.html',
    styleUrls: ['./reactivate.component.scss'],
    imports: [TranslocoDirective, ReactivatePaymentComponent, IconLoadingComponent]
})
export class ReactivateComponent implements OnInit {
  loading = true;
  error = '';
  subscriptionDebt: ZenriseDebtData;

  private route = inject(ActivatedRoute);
  private reactivateService = inject(ReactivateService);
  private appCurrencyFormatService = inject(AppCurrencyFormatService);

  constructor() {}

  ngOnInit(): void {
    const subscriptionId = this.route.snapshot.paramMap.get('subscriptionId');

    this.reactivateService
      .getDebt(subscriptionId)
      .pipe(take(1))
      .subscribe(
        data => {
          console.log(data);
          this.subscriptionDebt = data.data;
          this.appCurrencyFormatService.currencyCode =
            this.subscriptionDebt.subscription.countryCode;
          this.loading = false;
        },
        ({ error }) => {
          this.error = error.message;
          this.loading = false;
        },
      );
  }
}
